import { combineReducers } from "redux";
import rentalpropertyinquiry from "../features/admin/rentalinquiry/Slice";

const getrental = combineReducers({
  rentalpropertyinquiry: rentalpropertyinquiry,
});

export default getrental;
